<template>
  <header class="flex flex-row justify-between items-center relative">
    <nav>
      <ul class="flex flex-row list-none mt-0">
        <li>
          <router-link
            to="/"
            exact
            exact-active-class="font-bold"
            :class="linkClasses"
            >Home</router-link
          >
        </li>
        <li>
          <router-link to="/work" active-class="font-bold" :class="linkClasses"
            >Work</router-link
          >
        </li>
      </ul>
    </nav>
    <theme-toggle />
  </header>
</template>

<script>
import ThemeToggle from "./ThemeToggle";

/**
 * @name Main Navigation
 * @description Contains page links and theme toggler
 * @example <navigation />
 */
export default {
  components: {
    ThemeToggle
  },
  data: () => ({
    linkClasses: "link link--hover mr-6"
  })
};
</script>
